import useOnboardingVisibility from '../hooks/useOnboardingVisibility.js'
import { getOnboardingMessage } from '../utils/onboardingRegistry.js'

function DismissibleOnboardingMessage({
  messageId,
  storageKey,
  eyebrow,
  title,
  description,
  isVisible,
  onDismiss,
  className = '',
}) {
  const registryMessage = messageId ? getOnboardingMessage(messageId) : null
  const resolvedStorageKey = storageKey || registryMessage?.storageKey
  const resolvedEyebrow = eyebrow || registryMessage?.eyebrow
  const resolvedTitle = title || registryMessage?.title
  const resolvedDescription = description || registryMessage?.description
  const { isVisible: hookVisible, dismiss: hookDismiss } = useOnboardingVisibility(resolvedStorageKey)
  const resolvedIsVisible = typeof isVisible === 'boolean' ? isVisible : hookVisible
  const resolvedDismiss = typeof onDismiss === 'function' ? onDismiss : hookDismiss

  if (!resolvedStorageKey || !resolvedTitle || !resolvedDescription) return null

  if (!resolvedIsVisible) return null

  return (
    <header
      className={`shop-page-intro shop-page-intro-minimal onboarding-message ${className}`.trim()}
    >
      <button
        type="button"
        className="onboarding-dismiss-btn"
        onClick={resolvedDismiss}
        aria-label={`Dismiss ${resolvedTitle} onboarding message`}
      >
        <i className="fas fa-times" aria-hidden="true" />
      </button>
      {resolvedEyebrow && <p className="eyebrow planner-eyebrow-tight">{resolvedEyebrow}</p>}
      <h1 className="h-display shop-page-heading">{resolvedTitle}</h1>
      <p className="shop-page-lede">{resolvedDescription}</p>
    </header>
  )
}

export default DismissibleOnboardingMessage
